export const isEducationalEmail = (email: string): boolean => {
  const lowerCaseEmail = email.toLowerCase();
  const endsWithEdu = lowerCaseEmail.endsWith('.edu');
  const containsCollege = lowerCaseEmail.includes('college');
  const containsUniversity = lowerCaseEmail.includes('university');
  const containsSchool = lowerCaseEmail.includes('school');
  return endsWithEdu || containsCollege || containsUniversity || containsSchool;
};
